import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';

export function Version({ size }) {
  const intl = useIntl();

  const [selectedMetadata, setSelectedMetadata] = useAtom(selectedMetadataAtom);

  const options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((option) => ({
    label: option.toString(),
    value: option.toString(),
  }));
  return (
    <Dropdown
      id="version-select"
      label={intl.formatMessage({ defaultMessage: 'Version', id: '34b6c' })}
      labelPosition="top"
      onChange={(selectedOption) =>
        setSelectedMetadata({
          ...selectedMetadata,
          version: selectedOption.value,
        })
      }
      options={options}
      placeholder={intl.formatMessage({
        defaultMessage: 'Version',
        id: '34b6c',
      })}
      size={size}
      value={options.find(
        (option) => option.value === selectedMetadata.version.toString(),
      )}
      variant="secondary"
    />
  );
}

Version.propTypes = {
  size: PropTypes.string,
};
Version.defaultProps = {
  size: undefined,
};

export default { Version };
